import { trackEvent as t } from '../track';
import {
  DocumentListProps,
  FilterProps,
  DocumentMetadataProps,
  SearchProps,
} from './propertyTypes';

interface DocumentListPinProps extends DocumentListProps, DocumentMetadataProps {}
export interface DocumentListDocActionProps
  extends DocumentListProps,
    FilterProps,
    DocumentMetadataProps,
    SearchProps {}
export interface DocumentListViewProps extends DocumentListProps, FilterProps, SearchProps {}

export const documentList = {
  pinning: {
    createComplete: (props: DocumentListPinProps) =>
      t('[Document List] [Pinning] Create complete', props),
    createHover: (props: DocumentListPinProps) =>
      t('[Document List] [Pinning] Create hover', props),
    removeComplete: (props: DocumentListPinProps) =>
      t('[Document List] [Pinning] Remove complete', props),
    removeHover: (props: DocumentListPinProps) =>
      t('[Document List] [Pinning] Remove hover', props),
  },
  openDocument: (props: DocumentListDocActionProps) => t('[Document List] Open document', props),
  selectCollaborator: (props: DocumentListDocActionProps) =>
    t('[Document List] Select collaborator', props),
  selectOwner: (props: DocumentListDocActionProps) => t('[Document List] Select owner', props),
  view: (props: DocumentListViewProps) => t('[Document List] View', props),
};
